import { type ReactElement } from 'react'
import { type RenderRequestServerData, type UserAgentString } from 'src/lib/services/server-data'

import { useAppInit } from '@lib/hooks/app'
import { CommonServicesContext } from '@lib/services'

export interface BasePageProps {
  requestData?: RenderRequestServerData
  userAgent?: UserAgentString
}

export function withServices<T extends object>(
  Component: (props: T) => ReactElement,
): (props: T & BasePageProps) => ReactElement {
  return ({ requestData, userAgent, ...pageProps }) => {
    const [commonServices] = useAppInit(requestData, userAgent)

    return (
      <CommonServicesContext.Provider value={commonServices}>
        <Component {...(pageProps as T)} />
      </CommonServicesContext.Provider>
    )
  }
}
